import React from 'react';
import { sortBy, prop } from 'ramda';
import { useIntl } from 'gatsby-plugin-intl';

import { Blockquote, ContentMarkdown } from './quote.styles';

const renderElement = ({ name, value }, key) => {
  const intl = useIntl();
  return (
    <ContentMarkdown name={name} key={key}>
      {intl.formatMessage({ id: value })}
    </ContentMarkdown>
  );
};

export const Quote = ({ elements = [], children }) => {
  const orderedElements = sortBy(prop('order'))(elements);

  return (
    <Blockquote>
      {orderedElements.map(renderElement)}
      {children}
    </Blockquote>
  );
};
